import React from "react";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import EmergencyShareRoundedIcon from '@mui/icons-material/EmergencyShareRounded';
import { Link } from "react-router-dom";

import Style from "../../../styles/js/Styles.js";

import emergencyService from "../../../plas/services/emergency/service";

export default function CultureMenu( ) {

  const style = Style();
  
  return (
    <div>
    	{ emergencyService.canAdmin() && (
	      <ListItem button component={Link} to={"/emergency/live"} >
	        <ListItemIcon>
	          <EmergencyShareRoundedIcon />
	        </ListItemIcon>
	        <ListItemText className={style.menuTextItem} primary="Emergencias" />
	      </ListItem>
      	)}
    </div>
    
  );
}
